<!--
 * @Author: cmchiu
 * @Date: 2022-05-20 17:15:23
 * @LastEditTime: 2023-07-03 13:00:20
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\components\ItemInfoList\iteminfolist.vue
 * 
-->
<template>
    <div class="item-info-ls">
        <ul v-for="item in list" :key="item.key">
            <li>
                <span v-if="item.urlDisabled" class="el-link" style="cursor: auto" :id="item.title">
                    <b>{{ item.title }}</b>
                </span>
                <el-link
                    v-else
                    :href="item.url"
                    :target="item.target"
                    :rel="item.target === '_blank' ? 'noreferrer noopener' : ''"
                    :id="item.title"
                    :title="`${item.title}${item.target === '_blank' ? '（另開視窗）' : ''}`"
                    tabindex="0"
                >
                    <b>{{ item.title }}</b>
                </el-link>
                <br />
                <div class="item-info" v-html="item.info"></div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'itemInfoLs',

    props: {
        datas: {
            type: [String, Array, Object],
            default: null,
        },
    },

    data: function () {
        return {
            list: this.datas,
        }
    },
}
</script>

<style scoped lang="scss">
.item-info-ls {
    li {
        list-style-type: none;
        margin: 12px 0;
        border-bottom: 1px #ccc dashed;

        .item-info {
            margin-top: 5px;
            margin-bottom: 10px;
            font-size: 0.83333em;
        }

        a.el-link:focus {
            border: 0.1em #fff solid;
            box-shadow: 0 0 0 0.1em #000 inset;
            border-radius: 0.25em;
            padding: 0.1em 0.2em;
        }
    }
}
</style>
